import script from "./LevelDisplay.vue?vue&type=script&setup=true&lang=js"
export * from "./LevelDisplay.vue?vue&type=script&setup=true&lang=js"

import "./LevelDisplay.vue?vue&type=style&index=0&id=5c0416f8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c0416f8"]])

export default __exports__